import {
  CraftnoteEvent,
  createCraftnoteEventBuilder,
  GlobalCraftnoteEventParameters
} from "./CraftnoteEvent.generated";
/**
* Container for all events for Templates & PDF
*
*
* this file was auto-generated Craftnote Events Code Generator, for more info visit: https://github.com/craftnote/craftnote-events
*/
export type TemplatesParameters = TemplatesPdfEditCreatedParameters | TemplatesPdfEditClosedParameters | TemplatesPdfAnnotationCreatedParameters | TemplatesPdfSignatureCreatedParameters | TemplatesOnboardingClosedParameters | TemplatesHintClosedParameters | TemplatesHintCtaOpenedParameters;
export type TemplatesEvents = TemplatesPdfEditCreatedEvent | TemplatesPdfEditClosedEvent | TemplatesPdfAnnotationCreatedEvent | TemplatesPdfSignatureCreatedEvent | TemplatesOnboardingClosedEvent | TemplatesHintClosedEvent | TemplatesHintCtaOpenedEvent;

export interface TemplatesPdfEditCreatedParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
	projectId: string; // ID of the affected project
	context: string; // the context of the editing dialog, can be one of "chat", "files", "tasks"
	fromTemplate: boolean; // whether the PDF was created from a template
	finalize: boolean; // whether the PDF was saved with the finalize option
	overwrite: boolean; // whether the PDF was saved with the overwrite option, use false if overwrite is not available
}

export type TemplatesPdfEditCreatedParametersSpecific = Omit<
	TemplatesPdfEditCreatedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const templatesPdfEditCreatedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class TemplatesPdfEditCreatedEventBuilder {
	constructor(private specificParameters: TemplatesPdfEditCreatedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<TemplatesPdfEditCreatedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			TemplatesPdfEditCreatedParametersSpecific,
            TemplatesPdfEditCreatedParameters,
			(params: TemplatesPdfEditCreatedParameters) => TemplatesPdfEditCreatedEvent
		>(this.specificParameters, templatesPdfEditCreatedParametersGlobal, globalParams, (params) => new TemplatesPdfEditCreatedEvent(params));
	}
}

/**
 * A user saved an edited PDF. This can be triggered from the chat, the files section, or the tasks.
 */
export class TemplatesPdfEditCreatedEvent extends CraftnoteEvent<TemplatesPdfEditCreatedParameters>{
  constructor(parameters: TemplatesPdfEditCreatedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "pdf_save_succeeded"
		},
		{
			name: "iterable",
			eventName: "templates_pdf_edit_created"
		},
	]);
  }
}
export interface TemplatesPdfEditClosedParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
	projectId: string; // ID of the affected project
	context: string; // the context of the editing dialog, can be one of "chat", "files", "tasks"
	wasEdited: boolean; // whether the PDF was edited before closing
}

export type TemplatesPdfEditClosedParametersSpecific = Omit<
	TemplatesPdfEditClosedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const templatesPdfEditClosedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class TemplatesPdfEditClosedEventBuilder {
	constructor(private specificParameters: TemplatesPdfEditClosedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<TemplatesPdfEditClosedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			TemplatesPdfEditClosedParametersSpecific,
            TemplatesPdfEditClosedParameters,
			(params: TemplatesPdfEditClosedParameters) => TemplatesPdfEditClosedEvent
		>(this.specificParameters, templatesPdfEditClosedParametersGlobal, globalParams, (params) => new TemplatesPdfEditClosedEvent(params));
	}
}

/**
 * A user closed the PDF editing dialog without saving.
 */
export class TemplatesPdfEditClosedEvent extends CraftnoteEvent<TemplatesPdfEditClosedParameters>{
  constructor(parameters: TemplatesPdfEditClosedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "pdf_screen_aborted"
		},
		{
			name: "iterable",
			eventName: "templates_pdf_edit_closed"
		},
	]);
  }
}
export interface TemplatesPdfAnnotationCreatedParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
	projectId: string; // ID of the affected project
}

export type TemplatesPdfAnnotationCreatedParametersSpecific = Omit<
	TemplatesPdfAnnotationCreatedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const templatesPdfAnnotationCreatedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class TemplatesPdfAnnotationCreatedEventBuilder {
	constructor(private specificParameters: TemplatesPdfAnnotationCreatedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<TemplatesPdfAnnotationCreatedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			TemplatesPdfAnnotationCreatedParametersSpecific,
            TemplatesPdfAnnotationCreatedParameters,
			(params: TemplatesPdfAnnotationCreatedParameters) => TemplatesPdfAnnotationCreatedEvent
		>(this.specificParameters, templatesPdfAnnotationCreatedParametersGlobal, globalParams, (params) => new TemplatesPdfAnnotationCreatedEvent(params));
	}
}

/**
 * A user created a PDF annotation.
 */
export class TemplatesPdfAnnotationCreatedEvent extends CraftnoteEvent<TemplatesPdfAnnotationCreatedParameters>{
  constructor(parameters: TemplatesPdfAnnotationCreatedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "pdf_addAnnotation_saved"
		},
		{
			name: "iterable",
			eventName: "templates_pdf_annotation_created"
		},
	]);
  }
}
export interface TemplatesPdfSignatureCreatedParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
	projectId: string; // ID of the affected project
}

export type TemplatesPdfSignatureCreatedParametersSpecific = Omit<
	TemplatesPdfSignatureCreatedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const templatesPdfSignatureCreatedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class TemplatesPdfSignatureCreatedEventBuilder {
	constructor(private specificParameters: TemplatesPdfSignatureCreatedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<TemplatesPdfSignatureCreatedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			TemplatesPdfSignatureCreatedParametersSpecific,
            TemplatesPdfSignatureCreatedParameters,
			(params: TemplatesPdfSignatureCreatedParameters) => TemplatesPdfSignatureCreatedEvent
		>(this.specificParameters, templatesPdfSignatureCreatedParametersGlobal, globalParams, (params) => new TemplatesPdfSignatureCreatedEvent(params));
	}
}

/**
 * A user created a PDF signature.
 */
export class TemplatesPdfSignatureCreatedEvent extends CraftnoteEvent<TemplatesPdfSignatureCreatedParameters>{
  constructor(parameters: TemplatesPdfSignatureCreatedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "pdf_addSignature_saved"
		},
		{
			name: "iterable",
			eventName: "templates_pdf_signature_created"
		},
	]);
  }
}
export interface TemplatesOnboardingClosedParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
}

export type TemplatesOnboardingClosedParametersSpecific = Omit<
	TemplatesOnboardingClosedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const templatesOnboardingClosedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class TemplatesOnboardingClosedEventBuilder {
	constructor(private specificParameters: TemplatesOnboardingClosedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<TemplatesOnboardingClosedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			TemplatesOnboardingClosedParametersSpecific,
            TemplatesOnboardingClosedParameters,
			(params: TemplatesOnboardingClosedParameters) => TemplatesOnboardingClosedEvent
		>(this.specificParameters, templatesOnboardingClosedParametersGlobal, globalParams, (params) => new TemplatesOnboardingClosedEvent(params));
	}
}

/**
 * A user closed the templates onboarding dialog.
 */
export class TemplatesOnboardingClosedEvent extends CraftnoteEvent<TemplatesOnboardingClosedParameters>{
  constructor(parameters: TemplatesOnboardingClosedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "files_templates_onboarding_close"
		},
		{
			name: "iterable",
			eventName: "templates_onboarding_closed"
		},
	]);
  }
}
export interface TemplatesHintClosedParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
}

export type TemplatesHintClosedParametersSpecific = Omit<
	TemplatesHintClosedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const templatesHintClosedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class TemplatesHintClosedEventBuilder {
	constructor(private specificParameters: TemplatesHintClosedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<TemplatesHintClosedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			TemplatesHintClosedParametersSpecific,
            TemplatesHintClosedParameters,
			(params: TemplatesHintClosedParameters) => TemplatesHintClosedEvent
		>(this.specificParameters, templatesHintClosedParametersGlobal, globalParams, (params) => new TemplatesHintClosedEvent(params));
	}
}

/**
 * A user closed the template hint.
 */
export class TemplatesHintClosedEvent extends CraftnoteEvent<TemplatesHintClosedParameters>{
  constructor(parameters: TemplatesHintClosedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "filesSection_templates_hint_close"
		},
		{
			name: "iterable",
			eventName: "templates_hint_closed"
		},
	]);
  }
}
export interface TemplatesHintCtaOpenedParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
}

export type TemplatesHintCtaOpenedParametersSpecific = Omit<
	TemplatesHintCtaOpenedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const templatesHintCtaOpenedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class TemplatesHintCtaOpenedEventBuilder {
	constructor(private specificParameters: TemplatesHintCtaOpenedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<TemplatesHintCtaOpenedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			TemplatesHintCtaOpenedParametersSpecific,
            TemplatesHintCtaOpenedParameters,
			(params: TemplatesHintCtaOpenedParameters) => TemplatesHintCtaOpenedEvent
		>(this.specificParameters, templatesHintCtaOpenedParametersGlobal, globalParams, (params) => new TemplatesHintCtaOpenedEvent(params));
	}
}

/**
 * A user clicked on the CTA in the templates hint and gets redirected to the company templates.
 */
export class TemplatesHintCtaOpenedEvent extends CraftnoteEvent<TemplatesHintCtaOpenedParameters>{
  constructor(parameters: TemplatesHintCtaOpenedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "filesSection_templates_hint_redirect"
		},
		{
			name: "iterable",
			eventName: "templates_hint_cta_opened"
		},
	]);
  }
}
